export default class Vehicle {
    constructor() {
        this.vehicleMakeId = null;
        this.acquisitionId = null;

        this.vin = null;
        this.dateManufactured = null;
        this.dateAquired = null;
        this.purchasedForReSupply = null;

        this.dealerName = null;
        this.hadDirectToyotaDealershipPurchase = null;
        this.leasingCompany = null;
        this.onHirePurchaseCompany = null;
    }
}